module.exports = __webpack_public_path__ + "img/atlas-detail-bg.cb221c3c.webp";